import { h } from "./../../utils/createElement";
import { __extends } from "tslib";
import * as React from 'react';
import { emptyFn } from '../../utils/helper';
import { consumeTheme } from '../../utils/theme';
var Item = (function (_super) {
    __extends(Item, _super);
    function Item() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ref = React.createRef();
        _this.handleClick = function () {
            var _a = _this.props, onClick = _a.onClick, id = _a.id, disabled = _a.disabled;
            if (disabled) {
                return;
            }
            onClick(id);
        };
        _this.themedRender = function (classNames) {
            var _a, _b;
            var _c = _this.props, prefixCls = _c.prefixCls, className = _c.className, style = _c.style, description = _c.description, selected = _c.selected, title = _c.title, id = _c.id, disabled = _c.disabled, descriptionStyle = _c.descriptionStyle, titleStyle = _c.titleStyle, selectable = _c.selectable, titleClassName = _c.titleClassName, descriptionClassName = _c.descriptionClassName, icon = _c.icon;
            var classes = classNames(prefixCls, className, (_a = {},
                _a[prefixCls + "-selected"] = selected,
                _a[prefixCls + "-disabled"] = disabled,
                _a[prefixCls + "-with-icon"] = icon,
                _a));
            var containerClasses = classNames(prefixCls + "-container", (_b = {},
                _b[prefixCls + "-container-with-desc"] = description,
                _b[prefixCls + "-container-selectable"] = selectable,
                _b));
            return (h("li", { className: classes, style: style, onClick: _this.handleClick, ref: _this.ref },
                _this.renderIcon(classNames),
                h("span", { className: containerClasses },
                    h("span", { className: classNames(prefixCls + "-title", titleClassName), style: titleStyle }, title || id),
                    description ?
                        h("span", { className: classNames(prefixCls + "-desc", descriptionClassName), style: descriptionStyle }, description)
                        : null)));
        };
        return _this;
    }
    Item.prototype.componentDidMount = function () {
        if (this.props.selected) {
            this.ref.current.scrollIntoView();
        }
    };
    Item.prototype.render = function () {
        return consumeTheme(this.themedRender);
    };
    Item.prototype.renderIcon = function (classNames) {
        var _a = this.props, prefixCls = _a.prefixCls, icon = _a.icon;
        if (!icon) {
            return null;
        }
        return (h("div", { className: classNames(prefixCls + "-icon"), style: typeof icon === 'string' ? { backgroundImage: "url(\"" + icon + "\")" } : undefined }, React.isValidElement(icon) && icon));
    };
    return Item;
}(React.Component));
export default Item;
Item.defaultProps = {
    prefixCls: 'dui-m-actionsheet-item',
    onClick: emptyFn,
    id: '',
    selected: false,
    disabled: false,
};
